import { Fee } from "../model";
import { getLocalApi } from "./localApi";
import { getSelectedDivisionId } from "app/shared/division/selectedDivisionStorage";
import apiConfig from "app/api/apiConfig.json";
import { readHasActiveOffering, readIsUsedInActivePackage } from "./productDtoHelpers";

export async function getFeeById(Id: string):Promise<Fee|void> {
    const localApi = await getLocalApi();
    const divisionId = getSelectedDivisionId();
    const endpoint = apiConfig.fees_get_fee_by_id
        .replace("{divisionId}", divisionId.toString())
        .replace("{id}", Id);

    return await localApi.fetchSingle(
        endpoint,
    mapFee,
    "Failed to fetch fee byId");
}

function mapFee(fee: any): Fee {
    return {
        id: fee.id,
        name: fee.name,
        unitTypeId: fee.unitTypeId,
        unitTypeName: fee.unitTypeName,
        active: fee.active,
        lastModifiedDate: fee.lastModifiedDate ?? null,
        lastUpdatedBy: fee.lastUpdatedBy ?? fee.lastModifiedBy ?? "",
        entityUpdate: undefined,
        excludedBookingSystemIds: [],
        hasActiveOffering: readHasActiveOffering(fee),
        isUsedInActivePackage: readIsUsedInActivePackage(fee),
    }
}